import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1D2558', // B2B Deep Blue
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#DD8748', // Conversion Orange
            contrastText: '#ffffff',
        },
        background: {
            default: '#f8f9fa',
            paper: '#ffffff',
        },
        text: {
            primary: '#232836',
            secondary: '#4b5563',
        },
        error: {
            main: '#d32f2f',
        },
        success: {
            main: '#2e7d32',
        },
    },
    typography: {
        fontFamily: '"Rubik", "Helvetica", "Arial", sans-serif',
        h1: {
            fontWeight: 800,
            fontSize: '3rem', // 48px
            color: '#1D2558',
        },
        h2: {
            fontWeight: 700,
            fontSize: '2.5rem', // 40px
            color: '#1D2558',
        },
        h3: {
            fontWeight: 600,
            fontSize: '2rem', // 32px
            color: '#1D2558',
        },
        h4: {
            fontWeight: 600,
            fontSize: '1.5rem', // 24px
            color: '#232836',
        },
        body1: {
            fontSize: '1rem', // 16px
            lineHeight: 1.5,
            color: '#232836',
        },
        body2: {
            fontSize: '0.875rem', // 14px
            color: '#4b5563',
        },
        button: {
            fontWeight: 600,
            textTransform: 'none',
        },
    },
    shape: {
        borderRadius: 8, // Standard 8px radius
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    padding: '10px 24px',
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                    },
                },
                containedSecondary: {
                    '&:hover': {
                        backgroundColor: '#fe9215',
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)',
                    borderRadius: 12,
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: '#ffffff',
                        '& fieldset': {
                            borderColor: '#CACACA',
                        },
                        '&:hover fieldset': {
                            borderColor: '#DD8748',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#1D2558',
                        },
                    },
                },
            },
        },
    },
});

export default theme;
